<div class="flex place-items-center cursor-pointer tk-c-gray-9 text-sm"
     (mouseover)="onMouseOver()" (mouseleave)="onMouseLeave()">
  <mat-icon *ngIf="!isHoverd" fontIcon="close" class="mr-2"></mat-icon>
  <mat-icon *ngIf="isHoverd" fontIcon="cancel" class="mr-2"></mat-icon>
  <span class="">{{label}}</span>
</div>
